import { render, staticRenderFns } from "./AreasEditar.vue?vue&type=template&id=eda1fc16&scoped=true&"
import script from "./AreasEditar.vue?vue&type=script&lang=js&"
export * from "./AreasEditar.vue?vue&type=script&lang=js&"
import style0 from "./AreasEditar.vue?vue&type=style&index=0&id=eda1fc16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda1fc16",
  null
  
)

export default component.exports